module.exports = __webpack_public_path__ + "img/toggle.0bb79806.svg";